<template>
  <div class="no-auth-container">
    <img src="@/assets/no_access_pic.png" alt="" />
    <p class="tip-main">很抱歉，您无访问权限</p>
    <p class="tip-sub">如需访问，请联系管理员</p>
    <hl-button type="special" class="back__button" @click="$router.go(-2)">返回</hl-button>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scpoed>
.no-auth-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('../../assets/404_bg.jpg') no-repeat left center / cover;
  img {
    display: block;
    width: 420px;
    margin-top: 40px;
  }
  .tip-main {
    margin-top: 24px;
    margin-bottom: 16px;
    font-size: 30px;
    color: #333333;
    font-weight: 600;
  }
  .tip-sub {
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
  }
  .back__button {
    margin-top: 56px;
    width: 200px;
    height: 40px;
    border-radius: 4px;
  }
}
</style>
